





















































































import { Ref, Watch, Prop, Component, Vue, Inject } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { ValidationObserver } from 'vee-validate'
import { namespace } from 'vuex-class'
import { Project } from '@/api/model/project'
import { ActionAPI, ReferralAPI } from '@/api/backend-client'
import { Action } from '@/api/model/action'
import { ReferralStatus, ReferralType, ActionType } from '@/api/types'
import { v4 as uuid } from 'uuid'
import { CreateActionModel } from '@/components/form/CreateActionForm.vue'
const projects = namespace('projects')

@Component
export default class EditTaskModal extends Vue {
    @projects.State readonly projects!: Project[]
    @projects.Action applyCompanyFilter: (payload: { query: string }) => Promise<void>
    @Ref() validator!: InstanceType<typeof ValidationObserver>
    @Prop({ type: Boolean, required: true }) visible: boolean
    @Prop() readonly referral!: Referral
    @Prop({ type: Boolean, required: false }) disabled: boolean
    @Inject() reloadReferral: () => Promise<void>
    form: Referral = null
    modalVisible: boolean = false
    exampleEmailModalVisible = false
    exampleEmailBody: string = null

    mounted() {
        this.modalVisible = this.visible
    }

    @Watch('visible')
    onVisibleChange() {
        this.modalVisible = this.visible
    }

    @Watch('modalVisible')
    onModalVisibleChange() {
        if (this.modalVisible) {
            this.form = this.referral.clone()
            this.$emit('open')
        } else {
            this.form = null
            this.$emit('close')
        }
    }

    get shouldShowEmailPreview(): boolean {
        if (this.form.type !== ReferralType.NEW_BUILD) {
            return false
        }

        if (this.form.project === null) {
            return false
        }

        if (this.form.project.active === false) {
            return false
        }

        if (this.referral.actions.some((action: Action) => action.type === 'meeting') === false) {
            return false
        }

        return this.form.status === 'appointment'
    }

    async onSavePressed(): Promise<void> {
        const valid = await this.validator.validate()
        if (!valid) {
            setTimeout(() => {
                const errors = this.validator.errors
                const flatErrors = Object.values(errors).flat()

                this.$notify({
                    group: 'validation',
                    type: 'warn',
                    title: this.$t('validationError.title').toString(),
                    text: this.$t('validationError.text', { errors: flatErrors.join('<br>') }).toString().replace(/\n/g, '<br>'),
                })
            }, 32)
            return
        }

        // Delay submit and show modal first.
        if (this.shouldShowEmailPreview) {
            try {
                const data = await ReferralAPI.previewProjectEmailTemplate(
                    this.referral.id,
                    'project-services-introduction',
                )

                this.exampleEmailBody = data.html
                this.exampleEmailModalVisible = true
                return

            } catch (error) {
                this.$notify({
                    type: 'error',
                    title: this.$t('error.title').toString(),
                    text: this.$t('error.text', { message: error.message }).toString().replace(/\n/g, '<br>'),
                })
            }
        }

        // Just submit
        await this.submit()
    }

    submitting: boolean = false
    async submit(sendNotifyEmail: boolean = false) {

        try {
            this.exampleEmailModalVisible = false
            this.submitting = true
            await ReferralAPI.update(this.form.id, this.form)
            await this.reloadReferral()

            if (sendNotifyEmail) {
                await ReferralAPI.sendNewBuildProjectReferralEmail(
                    this.form.id,
                    'project-services-introduction',
                )
            }

            this.modalVisible = false

        } catch (error) {
            this.$notify({
                type: 'error',
                title: this.$t('error.title').toString(),
                text: this.$t('error.text', { message: error.message }).toString().replace(/\n/g, '<br>'),
            })
        } finally {
            this.submitting = false
        }
    }


    createAppointmentActionModal: boolean = false
    createAppointmentActionSaving: boolean = false
    createAppointmentAction: CreateActionModel = {
        ...Action.fromData({
            id: uuid(),
            referral: this.referral,
            type: ActionType.MEETING,
            appointmentType: null,
            actionDate: null,
            assignedTo: [],
            comment: '',
        }),

        notify: false,
    }

    @Watch('form.status')
    onStatusChanged() {
        if (!this.form) {
            return
        }

        // Check for existing appointment action when status changes to appointment
        if (this.form.status === ReferralStatus.APPOINTMENT) {
            const hasAppointment = this.form.actions.some((action: Action) => action.type === ActionType.MEETING)

            // Show create action modal.
            if (!hasAppointment) {
                this.createAppointmentActionModal = true
            }
        }
    }

    /**
     * Cancel creation of new appointment action.
     * This will close the modal and reset the referral status to its original value.
     * @param closeModal
     */
    async cancelCreateAppointmentAction(closeModal: () => void): Promise<void> {
        this.form.status = this.referral.status
        this.form.statusReason = this.referral.statusReason
        closeModal()
    }

    async saveCreateAppointmentAction(closeModal: () => void): Promise<void> {
        try {
            this.createAppointmentActionSaving = true
            const response = await ActionAPI.create({
                ...this.createAppointmentAction,
                comment: this.createAppointmentAction.comment ?? '',
                createdBy: this.$currentUser.resourceIdentifier,

                // @todo: not actually part of the model, should be a seperate call
                // @ts-ignore
                informAssignedTo: this.createAppointmentAction.notify,

            } as any)

            if (response instanceof Action) {
                this.referral.actions.push(response)
                closeModal()
            }

        } catch (error) {
            // notify, cancel
            console.log(error)

        } finally {
            this.createAppointmentActionSaving = false
        }
    }
}
